<template>
  <div
    :id="modalId"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="noteModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title" id="noteModalLabel" style="display: inline">
            Delete Note
          </h5>
          <button type="button" class="close" @click="hide">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
         <h5>You are about to <strong style="color: red;">DELETE</strong> this note. This action is irreversible.</h5>
        </div>
        <div class="modal-footer" style="border-top: none;">
          <button type="button" class="btn btn-primary mr-1" style="background-color: red;" @click="confirm">
            Delete
          </button>
          <button type="button" class="btn btn-secondary" @click="hide">
             Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'confirmRemoveModal',
  components: {
   
  },
  props: {
    modalId: {
      type: String,
      default: 'confirmRemoveModal',
    },
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
  watch: {
    
  },
  methods: {
    show() {
      // Используем id модалки
      this.$nextTick(() => {
        $(`#${this.modalId}`).modal('show');
      });
    },
    hide() {
      $(`#${this.modalId}`).modal('hide');
    },
    confirm() {
      this.$emit('confirm');
      this.hide();
    },
  },
};
</script>

<style scoped>
.modal-body{
    padding: 10px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
}
</style>
